module.exports = __WEBPACK_EXTERNAL_MODULE_165__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"React","commonjs":"react","commonjs2":"react","amd":"react"}
 ** module id = 165
 ** module chunks = 0
 **/